module.exports = __webpack_public_path__ + "img/orange_up_arrow.1a0b8b86.svg";